// preservation-allow — vague 4 lot 3 (chantier 3) : fetchAuthorRanking retiré (thunk mort,
// feature ranking archivée dans src/_archive/2026-07-04-vague4-http/). Zéro ref vivante.
import * as actions from '../../actions';
import * as AuthService from "../../../services/AuthService";

export const fetchAuthorList = (orderBy=1, orderDirection='desc') => async (dispatch) => {

  dispatch(actions.setLoading(true));
  dispatch(actions.getAuthorList.request());

  try {
    let params = {};
    params['orderBy'] = orderBy;
    params['orderDirection'] = orderDirection;

    const data = await AuthService.fetchUsers(params);

    dispatch(actions.setLoading(false));
    dispatch(actions.getAuthorList.success(data));
  } catch (err) {
    dispatch(actions.setLoading(false));
    dispatch(actions.getAuthorList.failure(err));
  }
};

export const fetchCurrentAuthor = (authorId, silent = false) => async (dispatch) => {

  // silent=true → ne déclenche PAS l'overlay de chargement global (backdrop sombre).
  // Utilisé par le panneau détail de la tile-map : c'est un fetch d'arrière-plan
  // (infos auteur) qui ne doit pas faire flasher un écran noir plein écran à chaque
  // clic sur un terrain. Les autres appelants (pages auteur) gardent le loading.
  if (!silent) dispatch(actions.setLoading(true));
  dispatch(actions.getCurrentAuthor.request());

  try {
    const data = await AuthService.fetchCurrentUser(authorId);

    if (!silent) dispatch(actions.setLoading(false));
    dispatch(actions.getCurrentAuthor.success(data));
  } catch (err) {
    if (!silent) dispatch(actions.setLoading(false));
    dispatch(actions.getCurrentAuthor.failure(err));
  }
};
